import React, { useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import ContentSlider from "../../components/ContentSlider/ContentSlider";
import { callApi } from "modules/core/api/services";
import "./Partner.css";
import { useParams } from "react-router-dom";
import { LoaderFullscreen } from "../../modules/core/components";

interface Venue {
  name: string;
  description: string;
}

export const Partner = () => {
  const [upcoming, setUpcoming] = useState<any[] | undefined>();
  const [highlights, setHighlights] = useState<any[] | undefined>();
  const [venue, setVenue] = useState<Venue | undefined>();
  const { uuid } = useParams();

  const venueData = useCallback(async () => {
    const venue = await callApi(`/v2/venues/${uuid}`);

    setVenue(venue);
    return;
  }, [uuid]);

  const eventData = useCallback(async () => {
    const venueUpcoming = await callApi(
      `/v2/${uuid}/events?event_type=upcoming&resource_type=venue&page=1&per_page=10`
    );

    const venueHighlight = await callApi(
      `/v2/${uuid}/events?event_type=highlights&resource_type=venue&page=1&per_page=10`
    );

    setUpcoming(venueUpcoming.data);
    setHighlights(venueHighlight.data);
    return;
  }, [uuid]);

  useEffect(() => {
    eventData();
    venueData();
  }, [eventData, venueData]);

  if (!venue) return <LoaderFullscreen />;

  return (
    <>
      <Breadcrumb title={`OFFICIAL PARTNER OF STAIDIUM`} />
      <Container fluid style={{ backgroundColor: "#000", color: "#fff" }}>
        <div className="partner-main" style={{ padding: "90px 50px 0px 50px" }}>
          <Row className="align-items-center">
            <Col lg={12}>
              <div className="about-cont text-white-style">
                <div className="mb-4">
                  <h2>{venue && venue?.name}</h2>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col
              lg={6}
              className="d-flex justify-content-center align-items-center"
            >
              <Image
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  overflow: "hidden",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "24vh"
                }}
                className="mb-4"
                width={"100%"}
                src="/hazelwood.jpg"
              />
            </Col>

            <Col
              lg={6}
              className="d-flex justify-content-center align-items-center"
            >
              <div className="about-cont text-white-style">
                <div>
                  <p>{venue && venue?.description}</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <Row>
          <ContentSlider
            title={`Upcoming ${venue && venue?.name} Live Event`}
            data={upcoming && upcoming}
            event={true}
            sport={"basketball"}
            type={'events'}
          />

          <ContentSlider
            title={`Latest ${venue && venue?.name} Matches`}
            data={highlights && highlights}
            event={true}
            sport={"basketball"}
            style={{ paddingBottom: "30px" }}
            type={'events'}
          />
        </Row>
      </Container>
    </>
  );
};
